<template>
    <div class="gj_right" style="min-height: 0px;">
      <div class="add_con_man">
        <form novalidate class="w622" data-vv-scope="form" style="">
          <table width="100%" border="0" cellspacing="0" cellpadding="0">
            <thead>
            <tr>
              <td align="right">开票单位：</td>
              <td class="pl_10">
                <input type="text" name="company" class="put_add_text" placeholder="开票单位(个人)名称" v-model="form.company">
              </td>
            </tr>
            <tr>
              <td align="right">纳税人识别号：</td>
              <td class="pl_10">
                <input type="text" name="taxNo" class="put_add_text" placeholder="纳税人识别号" v-model="form.taxNo">
              </td>
            </tr>
            </thead>
          </table>
        </form>
        <div style="height: 380px; overflow: scroll;">
          <table width="622" border="0" cellspacing="0" cellpadding="0">
            <thead>
            <tr>
              <td width="15%">
                <input type='checkbox' :checked="(selected.length === lists.length) && lists.length != 0" @click='checkedAll()'>
              </td>
              <td>名称</td>
              <td>支付金额</td>
            </tr>
            </thead>
            <tbody>
            <tr v-for="item in lists" :key="item.id">
              <td>
                <input type="checkbox" :value="item.id" :checked="selected.indexOf(item.id)>=0" @click='checkedOne(item.id)' />
              </td>
              <td>{{item.subject}}</td>
              <td>{{item.money}}</td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
</template>

<script>
  import '@/utils/validator.js'
  import clonedeep from 'lodash.clonedeep'
    export default {
      components: {},
      props: ['params'],
      data () {
        return {
          outputs: {},
          lists: [],
          isCheckedAll: false,
          prefix: this.$route.meta.prefix || '',
          selected: [],
          form: {
            company: '',
            taxNo: ''
          }
        }
      },
      watch: {
        'selected': {
          handler (val) {
            this.outputs.lists = val
          },
          deep: true
        }
      },
      created () {
        if (this.params.inputs.data) {
          this.lists = clonedeep(this.params.inputs.data)
        }
      },
      mounted () {
        this.outputs = {
          data: this.form
        }
      },
      methods: {
        checkedOne (id) {
          let idIndex = this.selected.indexOf(id)
          if (idIndex >= 0) {
            this.selected.splice(idIndex, 1)
          } else {
            this.selected.push(id)
          }
        },
        checkedAll () {
          this.isCheckedAll = !this.isCheckedAll
          if (this.isCheckedAll) {
            this.selected = []
            if (this.lists.length>0) {
              for (var i = 0; i<this.lists.length; i++) {
                this.selected.push(this.lists[i].id)
              }
            }
          } else {
            this.selected = []
          }
        }
      }
    }
</script>

<style scoped>
  .px_add_con table thead tr { background: none; }
  input[type=checkbox] {
    opacity: 1;
  }
</style>



// WEBPACK FOOTER //
// src/components/byl/InvoiceBox/index.vue